import React from 'react';
import { Link } from 'react-router-dom';

function LegalNav({ excludeLinks = [] }) {
  const links = [
    { to: '/about', label: 'About Us' },
    { to: '/contact', label: 'Contact Us' },
    { to: '/terms', label: 'Terms & Conditions' },
    { to: '/privacy', label: 'Privacy Policy' },
  ];

  const filteredLinks = links.filter(link => !excludeLinks.includes(link.to));

  return (
    <div className="legal-nav">
      {filteredLinks.map(link => (
        <Link key={link.to} to={link.to}>{link.label}</Link>
      ))}
    </div>
  );
}

export default LegalNav;
